import { Descriptions, Divider, Typography } from 'antd';

import { ApplicantProfileProfessionViewContainerApplicantUserFieldsFragment } from '../../../../generated';
import React from 'react';
import { ProfileHeader } from './profile-header';
import { HealthProfessionViewContainer } from '../../../shared/health-profession-view/health-profession-view-container';
import { CountryView } from '../../../shared/country-view';
import { DATE_FORMAT } from '../../../../constants';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { DateInformationFooter } from '../../../shared/date-information-footer';
import { Country } from '../../../../types/country';

dayjs.extend(utc);
const { Title } = Typography;
const TITLE = 'Professional Details';

interface ProfileProfessionViewProps {
  data: ApplicantProfileProfessionViewContainerApplicantUserFieldsFragment;
  countryData: Country[];
  onEdit: () => void;
}
const formatDate = (date: string) => {
  return dayjs(date).utc().format(DATE_FORMAT).toUpperCase();
}
const getCountryName = (countryCode: string, countryData: Country[]) => {
  const country = countryData.find((item) => item.countryCode === countryCode);
  return country ? country.countryName : null;
};
const renderAddress = (edu: any, countryData: Country[]) => {
  const issuingInstitutionAddress = edu.issuingInstitution?.issuingInstitution?.address;
  const otherIssuingInstitutionAddress = edu.otherIssuingInstitution;

  const address = issuingInstitutionAddress || otherIssuingInstitutionAddress;
  if (address) {
    const { addressLine1, city, stateOrProvince, zipOrPostalCode, country } = address;
    return (
      <>
      {addressLine1 && <> {addressLine1} <br /></>}
      {city &&  stateOrProvince && (
        <>
          {city}, {stateOrProvince}, {zipOrPostalCode || ''} <br />
        </>
      )}
      {country && <>{getCountryName(country, countryData)}</>}
      </>
    )
  }

  return 'N/A';
};


export const ProfileProfessionView: React.FC<ProfileProfessionViewProps> = (props) => {
  const countryCode = props.data?.personalInformation?.professional?.citizenshipAtTimeEnteredMedicalInstitution ?? '';
  return (
    <div className="flex flex-col space-y-4 w-[85%] md:w-auto">
      <ProfileHeader title={TITLE} onEdit={props.onEdit} />
      <Descriptions title={undefined} layout="vertical" size="small" column={2} className="w-[400px]">
        <Descriptions.Item label="Profession">
          <HealthProfessionViewContainer displayValueOnly={true} healthProfessionCode={props.data?.personalInformation?.professional?.healthProfession ?? ''} />
        </Descriptions.Item>

        <br />
        <Descriptions.Item >
        <CountryView countryCode={countryCode} label="Citizenship at the time entering educational institution" layout="vertical" />
        </Descriptions.Item>
      </Descriptions>
      <Title level={5}>Institution that issued your Primary Professional Credential</Title>
      <div style={{overflow: 'auto', marginBottom: '120px', paddingBottom: '10px'}}>
        {props.data?.personalInformation?.professional?.primaryEducationalInformation &&
        props.data?.personalInformation?.professional?.primaryEducationalInformation?.length > 0 ? (
          props.data?.personalInformation?.professional.primaryEducationalInformation.map((edu, index) =>
            edu ? (
              <React.Fragment key={edu.id}>
                <Descriptions title={undefined} layout="vertical" column={2} bordered={false} size="small" className="w-[400px] p-2 ">
                  <Descriptions.Item label="Degree Title">{edu.degreeTitle}</Descriptions.Item>
                  <Descriptions.Item label="">&nbsp;</Descriptions.Item>
                  <Descriptions.Item label="Attendance Start Date">{edu.attendanceStartedAt ? formatDate(edu.attendanceStartedAt) : 'N/A'}</Descriptions.Item>
                  <Descriptions.Item label="Attendance End Date">{edu.attendanceEndedAt ? formatDate(edu.attendanceEndedAt) : 'N/A'}</Descriptions.Item>
                  <Descriptions.Item label="Date Certificate Issued">{edu.degreeIssuedAt ? formatDate(edu.degreeIssuedAt) : 'N/A'}</Descriptions.Item>
                  <Descriptions.Item label="Graduation Year">{edu.graduationYear}</Descriptions.Item> 
                  <Descriptions.Item label="Institution Name">
                  {edu?.issuingInstitution?.id ? edu?.issuingInstitution?.entityName : "Other - " + edu?.otherIssuingInstitution?.name}
                  </Descriptions.Item>
                  <Descriptions.Item label="">&nbsp;</Descriptions.Item>
                    <Descriptions.Item label="Address">{renderAddress(edu, props.countryData)}</Descriptions.Item>         
                  <Descriptions.Item label="">&nbsp;</Descriptions.Item>
                </Descriptions>
                {props.data?.personalInformation?.professional?.primaryEducationalInformation &&
                  index < props.data?.personalInformation?.professional?.primaryEducationalInformation?.length - 1 && <Divider className="pl-10" />}
              </React.Fragment>
            ) : null
          )
        ) : (
          <Descriptions.Item>No primary education information available</Descriptions.Item>
        )}
      </div>
      <DateInformationFooter
        customStyle={{
          right: 0,
          width: "100%",
        }}
      />
    </div>
  );
};
